import { render, staticRenderFns } from "./caseHeads.vue?vue&type=template&id=4aff878c&scoped=true"
import script from "./caseHeads.vue?vue&type=script&lang=js"
export * from "./caseHeads.vue?vue&type=script&lang=js"
import style0 from "./caseHeads.vue?vue&type=style&index=0&id=4aff878c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff878c",
  null
  
)

export default component.exports